import { Action } from '@ngrx/store';
import { Status } from './status.model';

export const LIST = '[Status] List';
export const LIST_COMPLETE = '[Status] List Complete';
export const LIST_FAILED = '[Status] List Failed';

export class ListAction implements Action {
    readonly type = LIST;

    constructor(public payload: number) { }
}

export class ListCompleteAction implements Action {
    readonly type = LIST_COMPLETE;

    constructor(public payload: Status[]) { }
}

export class ListFailedAction implements Action {
    readonly type = LIST_FAILED;

    constructor(public payload: { error: any }) { }
}

export type Actions
    = ListAction
    | ListCompleteAction
    | ListFailedAction;
